<style scoped>
    li {
        list-style: decimal-leading-zero;
        font-size: 20pt;
        margin: 0 0 0 2em;
    }

        li span {
            font-size: 14pt;
        }
</style>
<template>
    <div class="row">
        <div class="col-md-12">
            <h3 >Configure Scanner</h3>
            <hr />
        </div>
        <div class="col-md-6">
            <br />
            <h3  class="text-info" v-if="!scanComplete">
            <i class="fa fa-info-circle"></i>
            Press Start Scanning and then use your scanner to scan the code on the right</h3>
            <div v-else>
                <div v-if="scannerResults.invalidParse">
                    <h4 class="text-danger">
                        <i class="fa fa-exclamation-triangle"></i>
                    Could not calibrate scanner! Contact Support.</h4>
                </div>
                <div v-else>
                    <h4 v-if="scannerResults.requiresEnter" class="text-danger">
                        <i class="fa fa-exclamation-triangle"></i>
                        Scanner needs to be configured to have Line feed after scan. Please refer to scanner manual to configure.
                    </h4>
                    <h4 v-else class="text-success">
                        <i class="fa  fa-check"></i>
                        Scanner is correctly configured
                    </h4>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <br /><br />
            <img src="../../../Assets/barcode.gif"
                 style="height:150px;width:150px" />
            <br /><br />
            <a v-if="!started" class="btn btn-primary" @click="start">Start Scanning</a>
            <a v-else class="btn btn-primary" @click="stop">Stop Scanning</a>
        </div>
        <div class="col-md-12">

        </div>

    </div>
</template>
<script>
    import moment from 'moment'

    export default {
        props: [],
        data: function () {
            return {
                started: false,
                scanComplete: false,
                buffer: [],
                codeBuffer: [],
                keyBuffer: [],
                scannerResults: {
                    invalidParse: false,
                    requiresEnter: false,
                    seperator: [],
                }
            }
        },
        methods: {
            start() {
                this.codeBuffer = []
                this.keyBuffer = []
                this.started = true;
                document.addEventListener("keydown", this.handleKeyDown);
            },
            stop() {
                console.log(this.keyBuffer)
                console.log(this.codeBuffer)
                document.removeEventListener("keydown", this.handleKeyDown);

                this.processScannerData();
                this.scanComplete = true;
            },
            handleKeyDown(ev) {
                this.keyBuffer.push(ev.key);
                this.codeBuffer.push(ev.keyCode);
                ev.preventDefault();
                ev.stopPropagation();
            },
            processScannerData() {
                var gtinDateBatch = "01150602927404991720050010M0517007Z"
                var Sn = "21X62A2JKANL64";


                var keyBufferString = "";
                var codeBufferString = "";
                for (var key of this.keyBuffer) {
                    keyBufferString += key + ","
                }
                for (var code of this.codeBuffer) {
                    codeBufferString += code + ","
                }


                if (this.keyBuffer[this.keyBuffer.length - 1] != "Enter") {
                    this.scannerResults.requiresEnter = true;
                }
                else {
                    this.scannerResults.requiresEnter = false;
                }

                var tbr = [];
                var index = this.keyBuffer.length - 1;
                while (index >= 0) {
                    if (this.keyBuffer[index] == "Shift"
                        || this.keyBuffer[index] == "$"
                        || this.keyBuffer[index] == "Enter") {
                        tbr.push(index)
                    }
                    index--;
                }

                for (var index of tbr) {
                    this.codeBuffer.splice(index, 1)
                    this.keyBuffer.splice(index, 1)
                }

                var gtinMatch = true;
                for (var index in gtinDateBatch) {
                    if (gtinDateBatch[index] != this.keyBuffer[index])
                        gtinMatch = false;
                }

                console.log("GTIN Match : " + gtinMatch)

                this.codeBuffer = this.codeBuffer.splice(gtinDateBatch.length, 100)
                this.keyBuffer = this.keyBuffer.splice(gtinDateBatch.length, 100)

                console.log(this.keyBuffer)
                console.log(this.codeBuffer)
                console.log(this.Sn)


                var snMatch = true;
                var snBuffer = this.keyBuffer.splice(this.keyBuffer.length - Sn.length);
                for (var index in snBuffer) {
                    if (snBuffer[index] != Sn[index]) {
                        snMatch = false
                    }
                }
                console.log("Serial Match : " + snMatch)
                if (!snMatch || !gtinMatch) {
                    this.scannerResults.invalidParse = true;
                }
                console.log(this.codeBuffer)
                var seperator = this.codeBuffer.splice(0, this.codeBuffer.length - Sn.length);
                console.log(this.codeBuffer)
                this.scannerResults.seperator = seperator;

                console.log(this.scannerResults);

                if (snMatch && gtinMatch) {
                    localStorage.setItem("ScannerSeperator", JSON.stringify(seperator));
                }


                var msg = (snMatch && gtinMatch) ? "Success" : "Failed";
                var data = {};
                data["keys"] = keyBufferString;
                data["codes"] = codeBufferString;
                // this.$root.UiSession.Log("ScannerConfig", msg, data);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ScannerCalibration.scp.html?6cfc13b3